export default __webpack_public_path__ + "static/media/GOAT-Logo.285491fd.png";